import { Component, OnInit, ViewChild, TemplateRef, Input, ElementRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { TreeRequest } from '../model/useraction/useractions';
import { CosyCommunicationControllerService } from '../service/controller/cosy-communication-controller.service';
import { UXControllerService } from '../service/controller/ux-controller.service';

@Component({
  selector: 'app-collection-createtree',
  templateUrl: './collection-createtree.component.html',
  styleUrls: ['./collection-createtree.component.css']
})
export class CollectionCreatetreeComponent implements OnInit {
  @ViewChild('coll') collTreeName: ElementRef;
  @ViewChild('newCollTreeTemplate')  newCollTreeTemplate: TemplateRef<any>;
  public modalRef: BsModalRef;

  constructor(
    private uxControllerService: UXControllerService,
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    private modalService: BsModalService) { }

  ngOnInit() {
  }

  public openNewCollTree(){
    this.modalRef = this.modalService.show(this.newCollTreeTemplate)
  }

  newTreeCollection(value:string){
    let treeRequest:TreeRequest = new TreeRequest();
    treeRequest.name = value;
    treeRequest.cosyToken = this.uxControllerService.sessionID;
    this.cosyCommunicationControllerService.executeTree('bf9bf4b1-b53c-41fe-a203-c39a5a99ac5b', treeRequest).subscribe(
      treeData => console.log(treeData),
      error => console.log(error),
    );

  }
}
